// extracted by mini-css-extract-plugin
export var arrows = "_5v-6";
export var decrementer = "_5v-a";
export var disabled = "_5v-4";
export var error = "_5v-1";
export var hiddenText = "_5v-b";
export var incrementer = "_5v-9";
export var input = "_5v-8";
export var inputWrapper = "_5v-0";
export var leadingIcon = "_5v-c";
export var readonly = "_5v-3";
export var regular = "_5v-7";
export var small = "_5v-5";
export var warning = "_5v-2";